export const POWER_SUBSTATION_DISTANCE_THRESHOLDS = [
  { category: "grid_power_substations", radiusMeters: 50_000 },
  { category: "bulk_power_substations", radiusMeters: 20_000 },
  { category: "primary_power_substations", radiusMeters: 5000 },
  { category: "hv_power_substations", radiusMeters: 2000 },
];
